import { Injectable } from '@angular/core';
import { TransformationType } from 'class-transformer';
import { FormArray, FormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { LocalizationService } from '../localization/localization.service';
import { TableParams } from 'src/app/models/table-params';
import { JsonPatchDocument } from 'src/app/models/json-patch-document';
import { AlertService } from 'src/app/shared/store/alert/alert.service';
import { AlertTypeEnum } from 'src/app/shared/store/alert/alert-type-enum';

@Injectable()
export class MappingUtilsService {
    constructor(public localizationService: LocalizationService) { }

    public static dateTransformer(value, obj, type) {
        if (value != null) {
            if (type == TransformationType.PLAIN_TO_CLASS)
                return new Date(value);
            else if (type == TransformationType.CLASS_TO_PLAIN) return value;
        } else return null;
    }

/*     public static formatDateTransformer(value, obj, type) {
        if (value != null) {
            if (type == TransformationType.PLAIN_TO_CLASS)
                return new Date(value);
            else if (type == TransformationType.CLASS_TO_PLAIN)
                return moment(value).format('Y-MM-DD');
            else return null;
        } else return null;
    } */

    public static transformRangeDate(data: any) {
        if (data) {
            data[0] = MappingUtilsService.dateTransformer(
                data[0],
                null,
                TransformationType.PLAIN_TO_CLASS
            );
            data[1] = MappingUtilsService.dateTransformer(
                data[1],
                null,
                TransformationType.PLAIN_TO_CLASS
            );
        } else return null;
    }

    public static MapJoin(
        llista: Array<any>,
        propietat: string,
        separador?: string
    ) {
        separador = separador || "','";
        let stringList: Array<string> = _.map(llista, (item) => {
            return item[propietat];
        });
        return _.join(stringList, separador);
    }

    public static Map(llista: Array<any>, propietat: string) {
        return _.map(llista, propietat);
    }

    public static ObjectToUrlString(object: any) {
        var queryString = Object.keys(object)
            .map((key) => {
                return object[key] != null && object[key] !== ''
                    ? key + '=' + object[key]
                    : '';
            })
            .filter((value) => value != '' && value != null)
            .join('&');

        return queryString;
    }

    public getValueForm(formGroup: FormGroup, id: string): any {
        return formGroup.get(id) ? formGroup.get(id).value : null;
    }

    public static ToArrayBytes(value, obj) {
        if (value && obj && value[obj]) {
            let fileArrayBuffer = value[obj];
            let result = window.btoa(fileArrayBuffer);

            return result;
        } else return null;
    }

    public static getArrayBuffer(file, isTextFile = false) {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onload = (evt: any) => {
                resolve(reader.result);
            };
            reader.onerror = (error) => {
                reject(error);
            };
            if (isTextFile) {
                //text
                reader.readAsBinaryString(file);
            } else {
                //altres
                reader.readAsArrayBuffer(file);
            }
        });
    }

    public static setTableParams(event: Event) {
        const tableParams = new TableParams();

        //tableParams.Rows = event.rows;
        //tableParams.First = event.first;
        //tableParams.SortBy = event.sortField;
        //tableParams.SortDirection = event.sortOrder;
        //tableParams.Filters = event.filters
        return tableParams;
    }

/*     public static setScrollParams(event: LazyLoadEvent) {
    const scrollParams = new ScrollParams();

    scrollParams.Rows = event.rows;
    scrollParams.First = event.first;
    scrollParams.SortBy = event.sortField;
    scrollParams.SortDirection = event.sortOrder;
    scrollParams.Filters = event.filters
    return scrollParams;
    }
 */
    public static getJsonPatchDocumentValues(obj: any, propertiesToPatch: string[] = null) {
        if (!propertiesToPatch) {
            propertiesToPatch = obj['propertiesToPatch']
        }
        let values: JsonPatchDocument[] = [];
        if (propertiesToPatch) {
            propertiesToPatch.forEach((prop) => {
                let value: JsonPatchDocument = new JsonPatchDocument(
                    prop,
                    'replace',
                    obj[prop]
                );
                values.push(value);
            });
        }
        return values;
    }

   /*  public static setDefaultControlIdiomas(array: FormArray, formBuilder: RxFormBuilder) {
        for (let i = 0; i < 7; i++) {
            array.push(formBuilder.group({
                idIdioma: [0],
                descrIdioma: [''],
                descr: [''],
            }));
        }
    } */

    public static normalizeParseFloat(number) {

        if (!(typeof number === 'string' || number instanceof String)) {
            return number;
        } else {


            number = number.indexOf(',') == -1 ? number + ",00" : number;

            number = number.replace(/[.]/g, '');
            number = number.replace(/[,]/g, '.');
            return parseFloat(number);
        }

    }

    public static normalizeToStringNumber(x) {
        if (x === null) {
            return '';
        } else {
            return x >= 0 ? this.replaceAll(this.replaceAll(this.replaceAll(this.formatDecimal(x), '.', '_'), ',', '.'), '_', ',') : '';
        }
    }

    private static replaceAll(string, search, replace) {
        return string.split(search).join(replace);
    }

    private static formatDecimal(num) {
        return ('' + num).replace(
            /(\d)(?=(?:\d{3})+(?:\.|$))|(\.\d\d?)\d*$/g,
            function (m, s1, s2) {
                return s2 || (s1 + ',');
            }
        );
    }

    public static setErrores(title: string, err: any, ctx: any, localizationService: LocalizationService, alertService: AlertService) {
        if (err.status === 500) {
            err = localizationService.translate("errors.unexpectedError");
        } else {
            err = localizationService.translate("errors.notFound");
        }

        ctx.patchState({
            error: err,
            isLoading: false,
        });

        let acceptButtonLabel = localizationService.translate("buttons.accept");
        alertService.alert(title, err, acceptButtonLabel, AlertTypeEnum.error, err).then(() => { });
        return err;
    }

    public static showError(title: string, details: string, alertService: AlertService, localizationService: LocalizationService) {
        let acceptButtonLabel = localizationService.translate("buttons.accept");
        alertService.alert(title, details, acceptButtonLabel, AlertTypeEnum.error, details).then(() => { });
    }
}
